export default "__VITE_ASSET__CqT3vATx__"